import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Bubble, LoaderButton, ContinueLabel } from 'ctia-ui';
import FormElement from 'components/FormElement';
import { handleInputChange, saveRequest } from 'actions/request';
import { submitWizardStep } from 'actions/wizard';

class ModelInfo extends Component {
  validate() {
    const { hwVersion, swVersion, descriptionOfChange } = this.props.request;

    return (
      hwVersion.length > 0 &&
      swVersion.length > 0 &&
      descriptionOfChange.length > 0
    );
  }

  render() {
    const {
      show,
      request,
      isEditable,
      canSave,
      canSubmit,
      handleInputChange,
      saveRequest,
      submitWizardStep,
      wizard
    } = this.props;

    if (!show) return null;

    return (
      <div>
        <Bubble show={!canSave}>
          Please enter the <strong>Hardware/Software versions</strong> for this
          request and the <strong>Description of Change</strong>.
        </Bubble>
        <Bubble show={canSave}>
          Below is the <strong>Hardware/Software versions</strong> and the{' '}
          <strong>Description of Change</strong> provided for this request.
        </Bubble>
        <Form horizontal>
          <FormElement
            type="text"
            id="hwVersion"
            label="HW Version"
            value={request.hwVersion}
            onChange={handleInputChange}
            editable={isEditable}
            maxLength="50"
          />
          <FormElement
            type="text"
            id="swVersion"
            label="SW Version"
            value={request.swVersion}
            onChange={handleInputChange}
            editable={isEditable}
            maxLength="50"
          />
          <FormElement
            type="text"
            id="descriptionOfChange"
            label="Description of Change"
            value={request.descriptionOfChange}
            onChange={handleInputChange}
            editable={isEditable}
          />
          <div className="text-right">
            <LoaderButton
              bsStyle="default"
              text="Save changes"
              disabled={!this.validate()}
              isLoading={request.isLoading}
              onClick={saveRequest}
              show={canSave}
            />
            <LoaderButton
              bsStyle="info"
              text={<ContinueLabel />}
              disabled={!this.validate()}
              isLoading={request.isLoading}
              onClick={() => submitWizardStep(wizard)}
              show={canSubmit}
            />
          </div>
        </Form>
      </div>
    );
  }
}

ModelInfo.propTypes = {
  show: PropTypes.bool,
  canSave: PropTypes.bool,
  canSubmit: PropTypes.bool
};

ModelInfo.defaultProps = {
  show: true,
  canSave: false,
  canSubmit: false
};

function mapStateToProps({ request, wizard }) {
  return { request, wizard };
}

export default connect(
  mapStateToProps,
  {
    handleInputChange,
    saveRequest,
    submitWizardStep
  }
)(ModelInfo);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/ModelInfo.js